// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__a6iFn","unreadBadge":"styles_unreadBadge__1nHtD","modalContent":"styles_modalContent__3fJuf","modal":"styles_modal__1U5w4"};